"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import n from "../components/Icon/SvgIcon.js";
const r = (e) => /* @__PURE__ */ o(
  n,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.131 8.256a.875.875 0 0 1 1.238 0L12 16.888l8.631-8.632a.875.875 0 1 1 1.238 1.238l-9.243 9.243a.885.885 0 0 1-1.252 0L2.131 9.494a.875.875 0 0 1 0-1.238",
        clipRule: "evenodd"
      }
    )
  }
), a = l(r);
export {
  a as ChevronDown,
  a as default
};
